import request from '@/axios'

/**
 * @Description: 获取应用软件发布列表
 * imgTodo
 */
export function getAppPublishList(data){
  return request({
    method: 'post',
    url: '/api/Applys/selectApplysListByCreateBy',
    data: data
  })
}

/**
 * @Description: 上传应用软件封面图片
 * imgHas
 */
export function uploadImage(data) {
  return request({
    method: 'post',
    url: '/api/image/uploadImage',
    data: data
  })
}

/**
 * @Description: 上传应用软件本体
 */
export function uploadApp(data) {
  return request({
    method: 'post',
    url: '/api/Applys/uploadApp',
    data: data
  })
}

/**
 * @Description: 批量发布
 */
export function batchPublish(ids) {
  return request({
    method: 'post',
    url: '/api/Applys/batchPublishingApplys',
    params: {
      ids: ids
    }
  })
}

/**
 * @Description: 批量取消发布
 */
export function batchCancelPublish(ids) {
  return request({
    method: 'post',
    url: '/api/Applys/batchCancellationApplys',
    params: {
      ids: ids
    }
  })
}

/**
 * @Description: 删除单个应用软件
 */
export function deleteApp(id) {
  return request({
    method: 'post',
    url: '/api/Applys/deleteApplysById',
    params: {
      id: id
    }
  })
}

/**
 * @Description: 添加、编辑应用软件，使用id来区分是添加还是编辑
 */
export function addorEditApp(data) {
  return request({
    method: 'post',
    url: '/api/Applys/addOrUpdateApply',
    data: data
  })
}

